import { useForm } from "react-hook-form";
import LeftLogoOverLay from "../common/layout/LeftLogoOverLay";
import TopLogoOverLay from "../common/layout/TopLogoOverLay";
import SubmitButton from "../common/SubmitButton";
import CustomNumberPatternField from "../common/custom-form-fields/CustomNumberPatternField";
import { passwordPattern, validateExpiryDate } from "../../utils/validation.util";
import CustomPasswordField from "../common/custom-form-fields/CustomPasswordField";
import { useNavigate, useParams } from "react-router-dom";
import toasty from "../../utils/toasty.util";
import axios from "axios";
import { useEffect } from "react";

const AddPayment = () => {

    const { control, watch, formState: { isSubmitting, errors }, handleSubmit } = useForm({ mode: 'onBlur' });
    const params = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        validateToken();
    }, []);



    const validateToken = async () => {
        try {

            await axios.get(`/api/common/valid-token/${params.token}`);
   
        } catch (error) {
            if (error?.response?.data?.message) {
                toasty.error(error?.response?.data?.message);
            } else {
                console.error(error);
            }
            navigate('/token-invalid')
        }
    }

    const onSubmit = async (formData) => {
        try {


            const { data } = await axios.post(`/api/client/salesRep-password-payment`, {
                creditCardNumber: formData.creditCardNumber,
                cardCVV: formData.cardCVV,
                cardExpiryDate: formData.cardExpiryDate,
                password: formData.password,
                clientId: params.clientId,
                token: params.token,
            });


            if (data.status === 0) {
                toasty.error(data.message);
                return;
            }

            toasty.success(data.message);

            setTimeout(() => {
                navigate('/login');
            }, 1000);

        } catch (error) {
            if (error?.response?.data?.message) {
                toasty.error(error?.response?.data?.message);
            } else {
                console.error(error);
            }
        }
    };


    return <>
    <div className="pt-2 ps-1">
        <TopLogoOverLay partnerType={''}></TopLogoOverLay>
        </div>
        <div className="container-fluid p-0 login-main-div overflow-auto-xs overflow-auto-sm ">
            <LeftLogoOverLay partnerType={''}></LeftLogoOverLay>
            <form onSubmit={handleSubmit(onSubmit)} className="login-form-height">
                <div className="container login-box  position-relative">
                    <div className="col-12 col-lg-6 d-flex align-items-center">
                        <div className="w-100 pt-5 mt-5 pt-md-0 mt-md-0">
                            {/* Heading */}
                                <h1 className="login-heading mb-1 font-24">Please enter your card details and password</h1>
                                <p className="font-16">You can set your monthly budget from settings to avoid unlimited spending.</p>
                            {/* Heading End */}

                            {/* form Fields Section */}
                            <div className="card-bg rounded p-4 mb-3">
                                <h1 className="font-16 text-black-dark">Add Card Details</h1>
                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-5 col-lg-5">
                                        <div className="mb-3 position-relative">
                                            <label className="stikkum-label">Card Number<span className="color-red">*</span></label>
                                            <CustomNumberPatternField
                                                control={control}
                                                format="###################"
                                                placeholder="Enter Card Number"
                                                className="stikkum-form-control custom-input"
                                                type="text"
                                                name="creditCardNumber"
                                                rules={{
                                                    required: "Card Number is required"
                                                }}
                                            />
                                            {errors.creditCardNumber && (
                                                <small className="invalid-field">{errors.creditCardNumber.message}</small>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                                        <div className="mb-3 position-relative">
                                            <label className="stikkum-label">Expiry Date<span className="color-red">*</span></label>
                                            <CustomNumberPatternField
                                                name="cardExpiryDate"
                                                format="## | ####"
                                                placeholder="MM | YYYY"
                                                control={control}
                                                className="stikkum-form-control custom-input"
                                                rules={{
                                                    required: "Expiry date is required",
                                                    validate: validateExpiryDate
                                                }}
                                            />
                                            {errors.cardExpiryDate && (
                                                <small className="invalid-field">{errors.cardExpiryDate.message}</small>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                                        <div className="mb-3 position-relative">
                                            <label className="stikkum-label">CVV Code<span className="color-red">*</span> </label>
                                            <CustomNumberPatternField
                                                name="cardCVV"
                                                control={control}
                                                format="####"
                                                className="stikkum-form-control custom-input"
                                                placeholder="CVV"
                                                rules={{
                                                    required: "CVV is required",
                                                    minLength: {
                                                        value: 3,
                                                        message: "Invalid CVV"
                                                    }
                                                }}
                                            />
                                            {errors.cardCVV && (
                                                <small className="invalid-field">{errors.cardCVV.message}</small>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-bg rounded p-4">
                                <h1 className="font-16 text-black-dark">Set Your Password</h1>
                                <div className="row">
                                    <div className="col-12 col-sm-6">
                                        <div className="mb-3 position-relative">
                                            <label className="stikkum-label">Password<span className="color-red">*</span></label>
                                            <CustomPasswordField
                                                className="input-form-control border-bottom-grey padding-right-30"
                                                name="password"
                                                control={control}
                                                rules={{
                                                    required: "Password is required",
                                                    pattern: passwordPattern,
                                                }}
                                                placeholder="Enter Password"
                                            />
                                            {errors.password?.message && (
                                                <small className="invalid-field">
                                                    {errors.password.message}
                                                </small>
                                            )}

                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="mb-3 position-relative">
                                            <label className="stikkum-label">Confirm Password<span className="color-red">*</span></label>
                                            <CustomPasswordField
                                                name="confirmPassword"
                                                control={control}
                                                rules={{
                                                    required: "Confirm Password is required",
                                                    validate: (values) =>
                                                        values === watch("password") ||
                                                        "Please enter the same value again",
                                                }}
                                                placeholder="Enter Password"
                                            />
                                            {errors.confirmPassword?.message && (
                                                <small className="invalid-field">
                                                    {errors.confirmPassword.message}
                                                </small>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* form Fields Section End */}

                            {/* Submit Button */}
                            <div className="col-12 p-0 mt-4 d-flex  justify-content-end">
                                <SubmitButton className='width-full-xs btn-orange-login btn-login-' isSubmitting={isSubmitting} loaderClass='submit-loader'>Submit</SubmitButton>
                            </div>
                            {/* Submit Button End */}
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </>
}

export default AddPayment;